export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const AGENTS = "AGENTS";
export const QUEUES = "QUEUES";
export const QUEUE_STATS = "QUEUE_STATS";
export const DASHBOARD_MAINCONTENT_HEADER = "DASHBOARD_MAINCONTENT_HEADER";
export const SIP_CONNECTION_STATUS = "SIP_CONNECTION_STATUS";
export const USER_DETAILS = "USER_DETAILS";
